@if (isLoading) {
  <div class="loading-state">
    <p>Loading...</p>
  </div>
} @else {
  @if (data?.length) {
    @for (contact of data; track contact.contactNumber; let i = $index) {
      @if (data.length > 1) {
        <div class="contact-header">
          <label>Emergency Contact {{ contact.contactNumber }}</label>
        </div>
      }
      @for (info of contact.contactData; track info) {
        <div class="info-content">
          <div class="heading">
            <label>{{ info.propertyName }}</label>
          </div>
          <div class="value">
            <p class="info">{{ info.propertyValue }}</p>
            <div class="line"></div>
          </div>
        </div>
      }
      @if (i < data.length - 1) {
        <div class="contact-separator"></div>
      }
    }
  } @else {
    <div class="no-record">
      <p>No Records</p>
    </div>
  }
}
